const PhoneIcon = () => (
  <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path
      d='M0.75 5.25C0.75 13.534 7.466 20.25 15.75 20.25H18C18.5967 20.25 19.169 20.0129 19.591 19.591C20.0129 19.169 20.25 18.5967 20.25 18V16.628C20.25 16.112 19.899 15.662 19.398 15.537L14.975 14.431C14.535 14.321 14.073 14.486 13.802 14.848L12.832 16.141C12.55 16.517 12.063 16.683 11.622 16.521C9.98488 15.9191 8.49815 14.9686 7.26478 13.7352C6.03141 12.5018 5.08087 11.0151 4.479 9.378C4.317 8.937 4.483 8.45 4.859 8.168L6.152 7.198C6.515 6.927 6.679 6.464 6.569 6.025L5.463 1.602C5.40214 1.35869 5.26172 1.1427 5.06405 0.988337C4.86638 0.833971 4.6228 0.750083 4.372 0.75H3C2.40326 0.75 1.83097 0.987053 1.40901 1.40901C0.987053 1.83097 0.75 2.40326 0.75 3V5.25Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default PhoneIcon
